'use strict';

var _ = require('lodash');
var WhatIfResultsController = function WhatIfResultsController($state, $scope, whatIfService, featureToggleService, dataRetrieverService, SearchCriteriaRule, criteriaService) {
  var ROWS_HEIGHT = 25;
  var MODES = {
    MARKET_DEMAND: 'MARKET_DEMAND',
    SERVICE: 'SERVICE',
    FLIGHT: 'FLIGHT'
  };
  $scope.availableModes = {
    MARKET_DEMAND: 'Market',
    SERVICE: 'Service',
    FLIGHT: 'Flight'
  };
  $scope.selectedRows = [];
  $scope.screenState = {
    rules: {},
    results: {},
    tabResults: undefined,
    selectedRule: undefined,
    selectedMode: undefined
  };
  $scope.rowDetailsTemplate = '<rm-what-if-row-details details-data="rowData"></rm-what-if-row-details>';
  $scope.getRowDetailsHeight = function (scope) {
    var maxSize = _.chain(scope.localData).map(function (row) {
      return row.appliedRules.length;
    }).max().value();
    return ROWS_HEIGHT * (3 + maxSize) - 10;
  };
  $scope.getSelectedMode = function () {
    return _.replace(_.lowerCase($scope.screenState.selectedMode), ' ', '-');
  };
  $scope.getSelectedModeLabel = function () {
    if (!$scope.screenState.selectedMode || $scope.screenState.tabResults && $scope.screenState.tabResults.length === 0) {
      return 'No entities';
    }
    return $scope.availableModes[$scope.screenState.selectedMode];
  };
  $scope.goBackToReadOnlyViewHandler = function () {
    $scope.$emit('readOnly:resetView');
  };
  $scope.collapseHandler = function () {
    $scope.$broadcast('grid:refresh:what-if-results-' + $scope.getSelectedMode());
  };
  $scope.isAnySelected = function () {
    return $scope.selectedRows && $scope.selectedRows.length > 0;
  };
  $scope.analyseSelected = function () {
    var selected = $scope.selectedRows;
    if (MODES.FLIGHT === $scope.screenState.selectedMode) return $state.go('app.flight-analysis', criteriaService.prepareFlightCriteria(selected));
    if (MODES.MARKET_DEMAND === $scope.screenState.selectedMode) return $state.go('app.market-analysis', criteriaService.prepareMarketCriteria(selected));
    if (MODES.SERVICE === $scope.screenState.selectedMode) return $state.go('app.market-analysis', criteriaService.prepareServiceCriteria(selected));
  };
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows || [];
  };
  $scope.openModalWindow = function (rule) {
    $scope.screenState.selectedRule = rule;
    $scope.$broadcast('rm-modal:show', 'whatIfModal');
  };
  function resetScreenState() {
    $scope.screenState.rules = {};
    $scope.screenState.results = {};
    $scope.screenState.tabResults = [];
    $scope.screenState.selectedRule = undefined;
    $scope.screenState.selectedMode = MODES.MARKET_DEMAND;
  }
  function fillRowDetails(results, rules) {
    _.forIn(results, function (value) {
      for (var rowIndex = 0, rowsLen = value.length; rowIndex < rowsLen; rowIndex++) {
        for (var ruleIndex = 0, rulesLen = value[rowIndex].appliedRulesData.length; ruleIndex < rulesLen; ruleIndex++) {
          var appliedRule = value[rowIndex].appliedRulesData[ruleIndex];
          appliedRule.name = _.get(rules[appliedRule.id], 'name', undefined);
          appliedRule.priority = _.get(rules[appliedRule.id], 'priority', undefined);
        }
      }
    });
  }
  $scope.selectedModeChanged = function () {
    if ($scope.screenState.results) {
      $scope.screenState.tabResults = $scope.screenState.results[$scope.screenState.selectedMode];
    }
  };
  whatIfService.getWhatIfResults($scope.whatIfStatus).then(function (data) {
    if (!data || _.isEmpty(data.results)) {
      resetScreenState();
      return;
    }
    fillRowDetails(data.results, data.rules);
    $scope.screenState.rules = data.rules;
    $scope.screenState.results = data.results;
    $scope.screenState.selectedMode = _.keys(data.results)[0] || MODES.MARKET_DEMAND;
    $scope.selectedModeChanged();
  });
};
WhatIfResultsController.$inject = ['$state', '$scope', 'WhatIfService', 'FeatureToggleService', 'DataRetrieverService', 'SearchCriteriaRuleFactory', 'WhatIfResultsCriteriaService'];
module.exports = WhatIfResultsController;